import React, { useEffect, useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import "../share-holders/share-holders.scss";
import useDirectorsForm from "./useDirectorsForm";
import useShareHolders from "../share-holders/useShareHolders";
import NoShareHolders from "../share-holders/NoShareHolders";
import ShareHoldersTable from "../share-holders/ShareHoldersTable";
import ShareHoldersRegistration from "../share-holders/ShareHoldersRegistration";
import AddDirectors from "./AddDirectors";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import DirectorsTable from "./DirectorsTable";
import Layout from "../../Layout";
import ReactCountryFlag from "react-country-flag";
import apiService from "../../services/service";
import API_ROUTES from "../../api-routes";
import { getName } from "country-list";
import { Skeleton } from "primereact/skeleton";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const Directors = () => {
  const {
    showRegistration,
    handleAddShareholderClick,
    handleSave,
    ShareHolders,
    successMessage,
    setSuccessMessage,
    shareLoading,
    setShareLoading,
  } = useShareHolders();

  const {
    handleDirectorClick,
    showDirectorsRegistration,
    directorsArr,
    setApiCall,
    loading,
    setLoading,
  } = useDirectorsForm();

  const navigate = useNavigate();
  const { id } = useParams();

  const location = useLocation();
  const [activeIndex, setActiveIndex] = useState(0);
  const [entity, setEntity] = useState({});

  const fetchEntityDetails = async () => {
    const { data } = await apiService(API_ROUTES.FETCH_ENTITY, "GET", {
      replace: { id },
    });
    setEntity(data);
  };

  useEffect(() => {
    fetchEntityDetails();
  }, []);

  useEffect(() => {
    if (location.pathname === `/entity/${id}/directors`) {
      setActiveIndex(0);
    } else if (location.pathname === `/entity/${id}/share-holders`) {
      setActiveIndex(1);
    }
  }, [location.pathname]);

  const handleTabChange = (e) => {
    navigate(`/entity/${id}/share-holders`);
    setApiCall(false);
  };
  useEffect(() => {
    if (ShareHolders) {
      const timeout = setTimeout(() => {
        setShareLoading(false);
      }, 200);
      return () => clearTimeout(timeout);
    }
  }, [ShareHolders]);

  useEffect(() => {
    if (showDirectorsRegistration) {
      navigate(`/entity/${id}/directors/add`);
    }
  }, [showDirectorsRegistration, navigate]);

  const subtitle =
    "Schedule and manage appointments related to this entity. Track changes in ownership and view the current ownership structure.";

  const [editPopup, setEditPopup] = useState(location.state?.editMessage || "");
  return (
    <Layout
      title="Directors & Shareholders"
      subtitle={subtitle}
      crumbs={[
        { label: "My Entities", url: "/entities" },
        {
          label: (
            <div className="flex">
              {!loading ? (
                entity?.name
              ) : (
                <Skeleton width="100px" height="20px" className="mr-1" />
              )}
              {!loading ? (
                " "
              ) : (
                <Skeleton width="10px" height="20px" className="mr-1" />
              )}
              {!loading ? (
                <>
                  (
                  <ReactCountryFlag
                    countryCode={entity?.country}
                    svg
                    className=""
                  />{" "}
                  {getName(entity?.country || "")})
                </>
              ) : (
                <Skeleton width="150px" height="20px" className="mr-1" />
              )}
            </div>
          ),
          id: "entity",
          url: `/entity/${id}/dashboard`,
        },
        { label: "Directors & Shareholders", id: "appointments-ownership" },
      ]}
    >
      {!showRegistration && !showDirectorsRegistration ? (
        <div>
          <div className="card">
            <TabView activeIndex={activeIndex} onTabChange={handleTabChange}>
              <TabPanel header="Directors" className="tab-panel">
                {directorsArr?.length !== 0 ? (
                  <DirectorsTable
                    directorsArr={directorsArr}
                    onDirectorClick={handleDirectorClick}
                    editPopup={editPopup}
                    setEditPopup={setEditPopup}
                    loading={loading}
                    setLoading={setLoading}
                  />
                ) : (
                  <NoShareHolders
                    directorTab={true}
                    onDirectorClick={handleDirectorClick}
                  />
                )}
              </TabPanel>
              <TabPanel header="Shareholders" className="tab-panel">
                <>
                  {ShareHolders?.length > 0 ? (
                    <ShareHoldersTable
                      onAddShareholderClick={handleAddShareholderClick}
                      successMessage={successMessage}
                      setSuccessMessage={setSuccessMessage}
                      shareLoading={shareLoading}
                    />
                  ) : !shareLoading && ShareHolders?.length === 0 ? (
                    <NoShareHolders
                      onAddShareholderClick={handleAddShareholderClick}
                    />
                  ) : (
                    <DataTable
                      value={Array(10).fill({})}
                      tableStyle={{ minWidth: "100%" }}
                      className="datatable-right-align"
                      paginator
                      rows={10}
                      rowsPerPageOptions={[10, 20, 30]}
                    >
                      <Column
                        header="Shareholder"
                        sortable
                        className="table-col-width"
                        body={<Skeleton />}
                      />
                      <Column
                        header="Type"
                        sortable
                        className="table-col-width"
                        body={<Skeleton />}
                      />
                      <Column
                        header="Number of Shares"
                        sortable
                        className="table-col-width"
                        body={<Skeleton />}
                      />
                      <Column
                        header="Share Percentage"
                        sortable
                        className="table-col-width"
                        body={<Skeleton />}
                      />
                      <Column className="table-col-width" body={<Skeleton />} />
                    </DataTable>
                  )}
                </>
              </TabPanel>
            </TabView>
          </div>
        </div>
      ) : showRegistration ? (
        <ShareHoldersRegistration onSave={handleSave} />
      ) : showDirectorsRegistration ? (
        <AddDirectors />
      ) : null}
    </Layout>
  );
};

export default Directors;
